import React from "react";
import SpotipitanAllSongs from "./spotipitan-all-songs/spotipitan-all-songs";
import SpotipitanHome from "./spotipitan-home/spotipitan-home";
import { MyProfile } from "../my-profile";
import { Route, Routes, useNavigate } from "react-router-dom";
import Spotip17anArtist from "./spotip17an-artist/spotip17an-artist";
import Spotip17anPlaylist from "./spotip17an-playlist/spotip17an-playlist";
import SpotipitanSearchResults from "./spotipitan-search-results/spotipitan-search-results";
import useUserStore from "../../../store/UserState";
import MyPlaylists from "./my-playlists";
import SavedPlaylists from "./saved-playlists";
import OfflinePlaylists from "./offline-playlists";
import Spotip17anMyLibrary from "./spotip17an-my-library/spotip17an-my-library";
import { LoginHome } from "../../users";
import { AppCustomize } from "./app-customize/app-customize";

const SpotipitanContent = () => {

    const user = useUserStore(state => state.state.user);
    const navigate = useNavigate();

    return (
        <Routes>
            <Route path="/" element={<SpotipitanHome />} />
            <Route path="all-songs" element={<SpotipitanAllSongs />} />
            <Route path="artist/:id" element={<Spotip17anArtist />} />
            <Route path="playlist/:id" element={<Spotip17anPlaylist />} />
            <Route path="search" element={<SpotipitanSearchResults />} />
            <Route path="offline-playlists" element={<OfflinePlaylists />} />
            <Route path="customize" element={<AppCustomize />} />
            {user?.uid && (
                <>
                    <Route path="my-user" element={<MyProfile />} />
                    <Route path='my-playlists' element={<MyPlaylists />} />
                    <Route path='saved-playlists' element={<SavedPlaylists />} />
                    <Route path='my-library' element={<Spotip17anMyLibrary />} />
                </>
            )}
            {!user?.uid && (
                <Route path="*" element={
                    <div className="fade custom-modal modal show" style={{
                        position: 'initial',
                        opacity: 1,
                        paddingBottom: '60px',
                        display: 'block',
                        height: 'fit-content',
                    }}>
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <LoginHome onClose={() => navigate("/")} />
                            </div>
                        </div>
                    </div>} />
            )}
        </Routes>
    )

}

export default SpotipitanContent;
